import { render } from "./AddProductToCartInstallmentsInformation.vue?vue&type=template&id=60f513e8"
import script from "./AddProductToCartInstallmentsInformation.vue?vue&type=script&lang=js"
export * from "./AddProductToCartInstallmentsInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__